import { render, staticRenderFns } from "./index.vue?vue&type=template&id=98e5e0bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=98e5e0bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e5e0bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98e5e0bc')) {
      api.createRecord('98e5e0bc', component.options)
    } else {
      api.reload('98e5e0bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=98e5e0bc&scoped=true", function () {
      api.rerender('98e5e0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChannelSelect/index.vue"
export default component.exports